import { map_size } from "./constants";
import { reloaded } from "./crank";
import { Ally, Enemy, units } from "./units";

const campaign_length = 600;
let campaign_progress = 0; 
const progress = document.getElementById("waveprogress") as HTMLDivElement

//to simplify: 
//create wave
//wait for wave to be defeated
//new wave

interface Wave{
    distances: number[],
    times: number[]
}

function addHostile(){
    const x = Math.random() * 760;
    const target = new Enemy(x, 0);
    units.push(target);
}

addHostile();

let wave = 0;

//I think we can refer to them as enemy platoons - its about the right size. 
//If we introduce friendly and unfriendly enemies, it should reduce the impact the player can really have. 
//This should lean further into the horror aspect I hope.

function spawnWave(){
    wave++;
    console.log("spawning wave ", wave);

    const enemy_count = 2 + Math.pow(wave, 1.2)
    for (let i = 0; i<enemy_count; i++){
        setTimeout(() => {
            addHostile()
        }, i * 2000);
    }
}

export function startCampaign(){

    for(let x = 100; x<map_size; x+=200){
        for(let y = 200; y<map_size; y+=200){
            if(y > 500 && Math.abs(400 - x) > 200){continue;}
            const ally = new Ally(x + (Math.random() - 0.5) * 100, y + (Math.random() - 0.5) * 100);
            units.push(ally);
        }
    }

    setInterval(() => {
        campaign_progress += 1;
        progress.style.width = Math.floor(campaign_progress*500/campaign_length) + "px";
        if(campaign_progress > wave * 120){
            spawnWave()
        }
    }, 1000);
}